// extracted by mini-css-extract-plugin
export default {"fadeOut":"sidebar_fadeOut__x5YU8","sidebarItem":"sidebar_sidebarItem__Ar7Y+","sidebarItemActive":"sidebar_sidebarItemActive__u4zn1"};